const candles = [
  { id: 1, label: 'Candle 1', o: '42,180', h: '42,590', l: '41,800', c: '42,440', signal: null },
  { id: 2, label: 'Candle 2', o: '42,440', h: '43,100', l: '42,300', c: '43,020', signal: null },
  { id: 3, label: 'Candle 3', o: '43,020', h: '43,850', l: '42,900', c: '43,710', signal: 'ENTRY' },
  { id: 4, label: 'Candle 4', o: '43,710', h: '44,200', l: '43,500', c: '44,050', signal: 'HOLD' },
  { id: 5, label: 'Candle 5', o: '44,050', h: '44,800', l: '43,900', c: '44,620', signal: 'TP HIT' },
];

const signalColor: Record<string, string> = {
  ENTRY: '#22c55e',
  HOLD: '#eab308',
  'TP HIT': '#3b82f6',
};

export default function CandleSimulationMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Bar-by-Bar Simulation</div>
      <div className="platform-mock-body" style={{ padding: '0.75rem 1rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'auto repeat(4, 1fr) auto', gap: '0 0.75rem', fontSize: 11, fontFamily: 'ui-monospace, monospace' }}>
          {/* Header */}
          <div style={{ color: '#6b7280', padding: '0.25rem 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>Bar</div>
          <div style={{ color: '#6b7280', padding: '0.25rem 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>Open</div>
          <div style={{ color: '#6b7280', padding: '0.25rem 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>High</div>
          <div style={{ color: '#6b7280', padding: '0.25rem 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>Low</div>
          <div style={{ color: '#6b7280', padding: '0.25rem 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>Close</div>
          <div style={{ color: '#6b7280', padding: '0.25rem 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>Signal</div>

          {candles.map((c) => (
            <span key={c.id} style={{ display: 'contents' }}>
              <div style={{ color: '#9ca3af', padding: '0.35rem 0' }}>{c.label}</div>
              <div style={{ color: '#d1d5db', padding: '0.35rem 0' }}>{c.o}</div>
              <div style={{ color: '#d1d5db', padding: '0.35rem 0' }}>{c.h}</div>
              <div style={{ color: '#d1d5db', padding: '0.35rem 0' }}>{c.l}</div>
              <div style={{ color: '#d1d5db', padding: '0.35rem 0' }}>{c.c}</div>
              <div style={{ padding: '0.35rem 0' }}>
                {c.signal ? (
                  <span style={{
                    color: signalColor[c.signal] || '#9ca3af',
                    fontWeight: 600,
                    background: `${signalColor[c.signal] || '#9ca3af'}18`,
                    padding: '1px 6px',
                    borderRadius: 3,
                  }}>{c.signal}</span>
                ) : (
                  <span style={{ color: '#4b5563' }}>&mdash;</span>
                )}
              </div>
            </span>
          ))}
        </div>

        <div style={{ marginTop: '0.75rem', padding: '0.5rem 0.75rem', background: 'rgba(34,197,94,0.06)', border: '1px solid rgba(34,197,94,0.15)', borderRadius: 6, fontSize: 11, color: '#9ca3af' }}>
          <span style={{ color: '#22c55e', fontWeight: 600 }}>Trade logged:</span> Entry 43,710 &rarr; Exit 44,620 &nbsp;|&nbsp; +2.08% &nbsp;|&nbsp; Duration: 2 bars
        </div>
      </div>
      <div className="platform-mock-caption">The engine steps through each candle, evaluating rules and tracking positions in real time.</div>
    </div>
  );
}
